@if (activePart(); as videoPart) {
    <div class="video-container container full-width" [class.embed]="embed()">
        @if (embed() && player.video?.paused) {
            <a routerLink="/{{AppRoutes.Videos}}/{{ video()!.slug }}" class="watch-on-link" target="_blank">
                <img src="assets/vln_default.svg" alt="Videolectures logo" />
                <fa-icon [icon]="faExternalLinkAlt" />
            </a>
        }
        <app-video-player #player [videoPart]="videoPart" [videoId]="video()!.id" [slides]="presentation()?.slides"
                          ngSkipHydration />
    </div>
    @if (!embed()) {
        <div class="about-video container" [class.with-slides]="!!presentation()">
            <div class="left">
                <div class="title-container">
                    <h1 class="title">{{ video()!.title }}</h1>
                    @if (isAdmin()) {
                        <a class="edit-link" routerLink="/admin/{{AdminRoute.Videos}}/{{video()!.id}}">
                            <fa-icon [icon]="faPenToSquare" />
                        </a>
                    }
                </div>
                <div class="video-info">
                    <span class="published">Published on {{ video()!.date }}</span>
                    <span class="bullet-separator"></span>
                    <span class="views">{{ video()!.total_views }} Views</span>
                    @if (video()?.license && Licences[video()!.license!]; as license) {
                        <span class="bullet-separator"></span>
                        <span class="licenses">
                    License
              <a [href]="license.link" class="license-icons">
                @for (icon of license.icons; track icon) {
                    <fa-icon [icon]="icon" />
                }
              </a>
                    </span>
                    }
                </div>
                <div class="line"></div>
                <div class="authors">
                    @for (author of video()?.authors; track author; let last = $last) {
                        <a routerLink="/{{AppRoutes.Authors}}/{{author.slug}}">
                            <h3>{{ author.name }}</h3>
                            @if (!last) {
                                <span class="comma-separator">,</span>
                            }
                        </a>
                    }
                </div>
                @if (video()!.description; as description) {
                    <div class="video-description mb-2">
                        <p [innerHTML]="description | slice: 0: !showMore() ? description.length : 200"></p>
                        @if (description.length > 200) {
                            <button class="read-more btn" (click)="showMore.set(!showMore())">
                                {{ showMore() ? "Read more" : "Read less" }}
                            </button>
                        }
                    </div>
                }

                @if (video()?.event; as event) {
                    <div class="lecture-event">
                        <fa-icon class="calendar-icon" [icon]="faCalendarDays" />

                        <a class="event-caption" routerLink="/{{AppRoutes.Events}}/{{event.slug}}">
                            <h2>{{ event.caption }}</h2>
                        </a>
                    </div>
                }

                <div class="btn-parent">
                    @if (isAuthenticated()) {
                        <app-playlist-dropdown [videoId]="video()!.id" />
                    }

                    <button class="btn btn-trans tooltip" (click)="toggleBookmark(video()!)"
                            [class.unauthenticated]="!isAuthenticated()">
                        {{ isBookmarked() ? "Bookmarked" : "Bookmark" }}
                        <fa-icon [icon]="isBookmarked() ? faBookmarkSolid: faBookmarkRegular" />
                        @if (!isAuthenticated()) {
                            <span class="tooltiptext">You&nbsp;need&nbsp;to&nbsp;login</span>
                        }
                    </button>
                    <button class="btn btn-trans tooltip-clipboard" [copyOnClick]="currentUrl" #copyUrl="copyDirective">
                        Share
                        <fa-icon [icon]="faShare" />
                        @if (copyUrl.showTooltip()) {
                            <span class="tooltiptext-clipboard">URL&nbsp;copied&nbsp;to&nbsp;clipboard</span>
                        }
                    </button>
                    <button class="btn btn-trans btn-embed tooltip-clipboard" [copyOnClick]="embedCode"
                            #copyEmbed="copyDirective">
                        Embed
                        <fa-icon [icon]="faLaptopCode" />
                        @if (copyEmbed.showTooltip()) {
                            <span class="tooltiptext-clipboard">Embed&nbsp;copied&nbsp;to&nbsp;clipboard</span>
                        }
                    </button>
                </div>

                @if (video()?.categories?.length) {
                    <app-related-categories [categories]="video()!.categories!" />
                }

                @if ((video()?.parts ?? []).length > 1) {
                    <div>
                        <h4 class="parts-title">Watch other parts:</h4>
                        <app-card-grid listView ngSkipHydration class="parts-list">
                            @for (part of video()?.parts; track part.part_number) {
                                @let isActive = part.part_number === videoPart.part_number;

                                <a class="part-item" [class.bg-gray]="isActive"
                                   routerLink="." [queryParams]="{part: part.part_number}">
                                    <span class="part-number">{{ part.part_number }}.</span>
                                    <app-video-item [video]="video()!" [part]="part" [listView]="true"
                                                    [class.bg-gray]="isActive" />
                                </a>
                            }
                        </app-card-grid>
                    </div>
                }
            </div>

            @if (presentation(); as presentation) {
                <div class="right chapter-list">
                    <div class="title-container">
                        <div class="chapter-title">
                            <h4>Presentation</h4>
                            @if (isAdmin()) {
                                <a class="edit-link"
                                   routerLink="/admin/videos/{{ video()!.id }}/sync/{{part()}}/{{presentation.language}}">
                                    <fa-icon [icon]="faPenToSquare" />
                                </a>
                            }
                        </div>

                        <button class="slides-toggle" (click)="toggleSlides()">
                            <fa-icon [icon]="slidesOpened() ? faChevronDown : faChevronUp" />
                        </button>
                    </div>
                    <div class="slides-list" [class.closed]="!slidesOpened()">
                        @for (slide of presentation.slides; track slide.id) {
                            <app-slide-item [slide]="slide" (onSelect)="selectSlide(slide)" />
                        }
                    </div>
                </div>
            }
        </div>
    }
} @else {
    <app-spinner />
}
